var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPartsConsumed({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "15px",
    viewBox: "0 0 16 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "BB6D3F5B-3D0F-4A6A-9BE0-DA497A01D459") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "AUDIT-&-ASSET-HISTORY-(REVISED)",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PANEL->-ASSET->-Asset-History->-Turbine-Log",
    transform: "translate(-715.000000, -796.000000)",
    fill: "#8694A1",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-8",
    transform: "translate(715.000000, 796.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    transform: "translate(12.547494, 11.718974) rotate(-45.000000) translate(-12.547494, -11.718974) ",
    points: "11.3673143 8.32384772 13.7755139 8.30692288 13.727673 15.1141004 11.3194734 15.1310252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2753281,5.97192617 C13.8137296,5.97192617 15.0651754,4.70276555 15.0651754,3.1425872 C15.0651754,2.67372532 14.9376395,2.23719874 14.7383647,1.84917511 L12.5861968,4.03180802 L11.3985189,2.82731801 L13.5506869,0.644685092 C13.1680792,0.442589452 12.7376457,0.313248242 12.2753281,0.313248242 C10.7369266,0.313248242 9.4854808,1.58240886 9.4854808,3.1425872 C9.4854808,3.47402405 9.54924874,3.78929325 9.65287164,4.08031098 L8.17823807,5.57581871 L6.75940145,4.13689775 L7.3253419,3.56294614 L6.20143199,2.42312673 L7.89128235,0.709355697 C6.95867625,-0.236451899 5.44418772,-0.236451899 4.51158163,0.709355697 L1.68985036,3.57102996 L2.81376027,4.71084937 L0.565940451,4.71084937 L0,5.28480099 L2.82173126,8.14647526 L3.38767172,7.57252364 L3.38767172,5.28480099 L4.51158163,6.4246204 L5.07752208,5.85066878 L6.4963587,7.28958974 L0.589853428,13.2797045 L2.27970379,14.9934755 L11.350693,5.80216583 C11.6376487,5.90725556 11.9485174,5.97192617 12.2753281,5.97192617 Z",
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartsConsumed);
export default __webpack_public_path__ + "static/media/parts-consumed.ebc2c8f0185ec29ac7564f36d4518126.svg";
export { ForwardRef as ReactComponent };